module.exports = __webpack_public_path__ + "img/banner-vaccine.af013fb4.jpg";